import { useNavigate } from 'react-router-dom';

import notepadIcon from 'assets/icons/notepad.svg';

import Auth from 'modules/Auth';
import { PermissionsEnum } from 'consts/permissions';
import SingleContent from 'components/common/layout/SingleContent';
import Button, { Color, Size } from 'lib/Button';

import ContentManagementHeader from '../ContentManagementHeader';
import Main from './Content';

const CreativeSets = (): React.ReactElement => {
  const navigate = useNavigate();

  const actionButton = Auth.hasPermission(PermissionsEnum.CONTENT_APPROVE) ? (
    <Button
      onClick={() => navigate('/content-management/creative-set-details')}
      color={Color.PRIMARY}
      size={Size.MEDIUM}
      dataTestId="create-button"
      label="Create set"
      ariaLabel="Open creative sets"
      svg={notepadIcon}
    />
  ) : null;

  return (
    <>
      <ContentManagementHeader actionButton={actionButton} />
      <SingleContent content={<Main />} />
    </>
  );
};

export default CreativeSets;
